import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Permissions from '../../../../data/permissions';
import Vehicle from './Vehicle';
import Geofence from './Geofence';
import Asset from './Asset';

class ResourceDetails extends React.Component {

    render() {
        const { resourceType, resourceId } = this.props.selectedResource;
        if(!resourceType) return null;
        switch(resourceType) {
            case 'geofence':
                return (<Geofence geofenceId={resourceId} stage={this.props.stage} pokeMap={this.props.pokeMap} editable={this.props.canEditGeofences} />);
            case 'asset':
                return (<Asset assetUuid={resourceId} stage={this.props.stage} pokeMap={this.props.pokeMap} editable={this.props.canEditAssets} />);
            case 'vehicle':
            default:
                return (<Vehicle {...this.props} />);
        }
    }
}

ResourceDetails.propTypes = {
    features: PropTypes.shape({
        debug: PropTypes.bool,
        media_request: PropTypes.bool,
    }).isRequired,
    stage: PropTypes.string.isRequired,
    theme: PropTypes.string.isRequired,
    selectedEvent: PropTypes.shape({
        media: PropTypes.arrayOf(PropTypes.shape({
            signedUrl: PropTypes.string
        }))
    }),
    selectedResource: PropTypes.shape({
        resourceType: PropTypes.string,
        resourceId: PropTypes.string,
    }).isRequired,
    selectedRaven: PropTypes.shape({
        ravenUuid: PropTypes.string.isRequired,
        noServicePlan: PropTypes.bool,
        dashboard: PropTypes.shape({
            events: PropTypes.arrayOf(PropTypes.object)
        })
    }),
    mqttService: PropTypes.object,
    unitOfMeasure: PropTypes.string.isRequired,
}


const mapStateToProps = state => {
    return {
        canEditGeofences: Permissions.selectors.can(state, 'geofences', 'write'),
        canEditAssets: Permissions.selectors.can(state, 'assets', 'write'),
    };
};

export default connect(mapStateToProps)(ResourceDetails);